import { StorefrontModule } from "@lib/appRegister";
import { CatalogStore } from "./store";

export const CatalogModule: StorefrontModule = function ({ store }) {
  store.registerModule("catalog", CatalogStore);

  store.dispatch("catalog/init");
};
